import React, { useState, useRef, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { Paperclip, Send } from "lucide-react";
import CustomerMasterLayout from "../../../../layouts/customer/CustomerMasterLayout";
import "../../../../assets/styles/customer/CustomerSupport.css";
import AppContext from "../../../../context/AppContext";
import axios from "axios";

const TICKETS = [
  {
    id: "TKT-101",
    subject: "Missed delivery on Feb 25",
    date: "Feb 25, 2026",
    status: "Open",
    messages: [
      {
        id: 1,
        from: "customer",
        text: "My milk was not delivered on Feb 25. Please check.",
        time: "10:00 AM",
      },
      {
        id: 2,
        from: "support",
        text: "Sorry for the inconvenience. Our rider was sick. We will adjust your bill.",
        time: "11:30 AM",
      },
      {
        id: 3,
        from: "customer",
        text: "Okay, please make sure it doesn't happen again.",
        time: "11:45 AM",
      },
    ],
  },
  {
    id: "TKT-098",
    subject: "Wrong quantity delivered",
    date: "Feb 10, 2026",
    status: "Resolved",
    messages: [
      {
        id: 1,
        from: "customer",
        text: "I ordered 2 litres but only 1 litre was delivered today.",
        time: "8:15 AM",
      },
      {
        id: 2,
        from: "support",
        text: "We apologize. The remaining 1 litre will be delivered today by 12 PM.",
        time: "9:00 AM",
      },
    ],
  },
];

const TICKET_TYPES = [
  "Dispute",
  "Delivery Issue",
  "Wrong Quantity",
  "Payment Issue",
  "Other",
];

/* ── Ticket Chat ── */
const TicketChat = ({ ticket, onBack }) => {
  const [message, setMessage] = useState("");
  const [msgs, setMsgs] = useState();
  const [file, setFile] = useState(null);
  const fileRef = useRef(null);
  const bottomRef = useRef(null);
  const { baseUrl } = useContext(AppContext);

  const loadChats = () => {
    const formData = new FormData();
    formData.append("mwhelpsupport_id", ticket.id);

    axios
      .post(`${baseUrl}/customer/chat/getMessages`, formData, {
        headers: { "Content-type": "multipart-formdata" },
      })
      .then((res) => {
        console.log("log from ticket message", res.data);
        if (res.data.success == true) {
          setMsgs(res.data.messages);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });

    console.log("this is active ticket ", ticket);
    loadChats();
  }, []);

  const handleSend = () => {
    const formData = new FormData();
    formData.append("mwhelpsupport_id", ticket.id);
    formData.append("message", message);

    axios
      .post(`${baseUrl}/customer/chat/sendMessage`, formData, {
        headers: { "Content-Type": "multipart/formdata" },
      })
      .then((res) => {
        console.log(res.data);
        if(res.data.success == true){
          loadChats();
          setMessage("");
        }

      })
      .catch((err) => {
        console.log(err)
      });
    // const text = message.trim();
    // if (!text && !file) return;
    // const time = new Date().toLocaleTimeString("en-US", {
    //   hour: "2-digit",
    //   minute: "2-digit",
    // });
    // setMsgs((prev) => [
    //   ...prev,
    //   {
    //     id: Date.now(),
    //     from: "customer",
    //     text: file
    //       ? `${text}${text ? " " : ""}[Attachment: ${file.name}]`
    //       : text,
    //     time,
    //   },
    // ]);
    // setMessage("");
    // setFile(null);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="csup-chat-wrapper">
      <button className="csup-back-btn" onClick={onBack}>
        <i className="bi bi-chevron-left me-1" />
        Back to Tickets
      </button>

      <div className="csup-chat-header">
        <div>
          <h2 className="csup-chat-title">
            #{ticket.id} — {ticket.subject}
          </h2>
          <p className="csup-chat-date">{ticket.created_at}</p>
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span
            className={`csup-status-badge csup-status-badge--${ticket.status.toLowerCase()}`}
          >
            <span
              className={`csup-status-dot csup-status-dot--${ticket.status.toLowerCase()}`}
            />
            {ticket.status}
          </span>
          {ticket.status === "open" && (
            <button className="csup-forward-btn">
              <i className="bi bi-box-arrow-up-right me-1" />
              Forward to Admin
            </button>
          )}
        </div>
      </div>

      <div className="csup-messages">
        {msgs?.map((msg) => (
          <div
            key={msg.id}
            className={`csup-msg-row csup-msg-row--${msg.sender}`}
            // className={`csup-msg-row--${msg.sender === "customer" ? "customer" : "support"`}
          >
            <div className={`csup-bubble csup-bubble--${msg.sender}`}>
              {/* <div className={`csup-bubble csup-bubble--customer`}> */}
              <p className="csup-bubble__text">{msg?.message}</p>
              <span className="csup-bubble__time">{msg.create_at}</span>
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      {/* Input row */}
      <div className="csup-input-row">
        {/* Attachment button */}
        <button
          className="csup-attach-btn"
          title="Attach file"
          // onClick={() => fileRef.current?.click()}
          onClick={handleSend}
        >
          <Paperclip size={17} />
        </button>
        <input
          ref={fileRef}
          type="file"
          style={{ display: "none" }}
          onChange={(e) => setFile(e.target.files[0] || null)}
        />

        <div className="csup-input-inner">
          {file && (
            <div className="csup-file-chip">
              <i className="bi bi-paperclip me-1" />
              <span>{file.name}</span>
              <button onClick={() => setFile(null)}>
                <i className="bi bi-x" />
              </button>
            </div>
          )}
          <input
            className="csup-msg-input"
            placeholder="Type a message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKey}
          />
        </div>

        <button className="csup-send-btn" onClick={handleSend}>
          <Send size={15} />
        </button>
      </div>
    </div>
  );
};

/* ── Support Main ── */
const SupportMain = ({ onOpen }) => {
  const [form, setForm] = useState({
    type: "Dispute",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState();
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  // const [milkEnteries, setMilkEnteries] = useState([]);
  const [disputes, setDisputes] = useState([]);
  const [msgs, setMsgs] = useState([]);
  const [message, setMessage] = useState("");
  const customerId = localStorage.getItem("customerId");
  const { baseUrl } = useContext(AppContext);

  const handleSubmit = () => {
    if (!form.subject.trim() || !form.message.trim()) return;
    setSubmitted(true);
    setForm({ type: "Dispute", subject: "", message: "" });
    setTimeout(() => setSubmitted(false), 3000);
  };

  const viewDisputes = () => {
    console.log("disputes showing");
    const formData = new FormData();
    formData.append("mwcustomer_id", customerId);

    axios
      .post(`${baseUrl}/customer/dispute/viewAllDisputes`, formData, {
        header: { "Content-type": "multipart-formdata" },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setDisputes(response.data.disputes);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewDisputes();
  }, []);

  // useEffect(() => {
  //   if (ticket?.id) {
  //     loadMessages();
  //   }
  // }, [ticket]);

  // const loadMessages = () => {
  //   const formData = new FormData();
  //   formData.append("mwhelpsupport_id", ticket.id);

  //   axios
  //     .post(`${baseUrl}/chat/get`, formData)
  //     .then((res) => {
  //       if (res.data.success) {
  //         setMsgs(res.data.messages || []);
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };
  useEffect(() => {
    if (disputes?.id) {
      loadMessages();
    }
  }, [disputes]);

  const loadMessages = () => {
    const formData = new FormData();
    formData.append("mwhelpsupport_id", disputes.id);

    axios
      .post(`${baseUrl}/customer/chat/getMessages`, formData)
      .then((res) => {
        if (res.data.success) {
          setMsgs(res.data.messages || []);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleSend = () => {
    const text = message.trim();

    if (!text) return;

    const formData = new FormData();
    formData.append("mwhelpsupport_id", disputes.id);
    formData.append("mwcustomer_id", customerId);
    formData.append("mwdistributor_id", disputes.mwdistributor_id);
    formData.append("message", text);

    axios
      .post(`${baseUrl}/customer/chat/sendMessage`, formData)
      .then((res) => {
        console.log(res.data); // 👈 debug (kyunki tum controller me return kar rahi ho request)

        // ⚠️ jab tum debug remove kar do gi tab yeh use hoga:
        // if (res.data.success) {
        //   setMsgs(prev => [
        //     ...(Array.isArray(prev) ? prev : []),
        //     res.data.data
        //   ]);
        // }

        setMessage("");
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="csup-header">
        <h1 className="csup-title">Support</h1>
        <p className="csup-subtitle">
          Raise disputes or create support tickets
        </p>
      </div>
      <Row className="g-4">
        {/* <Col xs={12} md={5}>
          <div className="csup-card">
            <h2 className="csup-card__heading">Raise a Ticket</h2>
            <div className="csup-form-group">
              <label className="csup-form-label">Type</label>
              <select className="csup-input csup-input--select" value={form.type} onChange={e => set('type', e.target.value)}>
                {TICKET_TYPES.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
            <div className="csup-form-group">
              <label className="csup-form-label">Subject</label>
              <input className="csup-input" placeholder="Brief subject" value={form.subject} onChange={e => set('subject', e.target.value)} />
            </div>
            <div className="csup-form-group">
              <label className="csup-form-label">Message</label>
              <textarea className="csup-input csup-input--textarea" placeholder="Describe your issue..." value={form.message} onChange={e => set('message', e.target.value)} rows={5} />
            </div>
            {submitted && <p className="csup-success">Ticket submitted successfully!</p>}
            <button className="csup-submit-btn" onClick={handleSubmit}>
              <i className="bi bi-chat-text me-2" />Submit Ticket
            </button>
          </div>
        </Col> */}
        <Col xs={12} md={12}>
          <div className="csup-card">
            <h2 className="csup-card__heading">Your Tickets</h2>
            <div className="csup-table-wrap">
              <table className="csup-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Subject</th>
                    <th>Distributor</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {disputes.map((e) => (
                    <tr key={e.id}>
                      <td>
                        <button
                          className="csup-ticket-id-btn"
                          onClick={() => onOpen(e)}
                        >
                          #{e.id}
                        </button>
                      </td>
                      <td className="csup-td--subject">
                        {e.subject ? e.subject.slice(0, 22) + "..." : e.subject}
                      </td>
                      <td>
                        <span
                          className={`csup-status-badge csup-status-badge--${e.status}`}
                        >
                          <span
                            className={`csup-status-dot csup-status-dot--${e.status}`}
                          />
                          {e.mwdistributor_id}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`csup-status-badge csup-status-badge--${e.status}`}
                        >
                          <span
                            className={`csup-status-dot csup-status-dot--${e.status}`}
                          />
                          {e.status}
                        </span>
                      </td>
                      <td>
                        <button
                          className="csup-chat-btn"
                          onClick={() => onOpen(e)}
                        >
                          <i className="bi bi-chat me-1" />
                          Chat
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

const CustomerSupport = () => {
  const [activeTicket, setActiveTicket] = useState(null);
  return (
    <CustomerMasterLayout>
      <div className="csup-wrapper">
        {activeTicket ? (
          <TicketChat
            ticket={activeTicket}
            onBack={() => setActiveTicket(null)}
          />
        ) : (
          <SupportMain onOpen={setActiveTicket} />
        )}
      </div>
    </CustomerMasterLayout>
  );
};

export default CustomerSupport;
